/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DifformitaStudente { 
    studente_id?: string;
    cognome?: string;
    nome?: string;
    codice_fiscale?: string;
    nome_scuola?: string;
    pasti_calcolati?: number;
    pasti_portafogli?: number;
    differenza?: number;
}

